import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { Service } from 'src/models/service/_types';
import { fetchServices } from 'src/models/service/service';

interface ServiceFilterProps {
  field: string;
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const ServiceFilter: React.FC<ServiceFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple,
}) => {
  const { data: services = [] } = useQuery({
    queryKey: ['services'],
    queryFn: () => fetchServices({ includePrivate: true }),
  });

  const serviceIds = value ? String(value).split(',') : [];

  let selectedService = undefined as Service | undefined;
  let selectedServices = [] as Service[];

  if (multiple) {
    selectedServices = services.filter((s) =>
      serviceIds?.includes(String(s.id))
    );
  } else {
    selectedService = services.find((s) => s.id == value);
  }

  if (valueOnly) {
    if (multiple) {
      return <>{selectedServices?.map((s) => s.name)?.join(', ')}</>;
    }
    return <>{selectedService?.name || ''}</>;
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={services}
      getOptionLabel={(option: Service) => option.name}
      value={multiple ? selectedServices : selectedService || null}
      onChange={(_, newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((s) => s.id).join(',')
          );
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Service" />
      )}
    />
  );
};
